var _path, _path2, _g, _g2, _path3, _g3, _path4, _path5, _path6, _path7, _path8, _g4, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 52,
    viewBox: "0 0 45 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 21.6064L25.2735 25.9912L14.7736 52L10.0281 46.9806L2.99998 47.6153L13.4999 21.6064Z",
    fill: "#BB3027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1385 21L14.3649 25.3847L24.8648 51.3936L29.6103 46.3742L36.6384 47.0088L26.1385 21Z",
    fill: "#BB3027"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0L23.3221 2.6821L26.8348 1.00334L28.69 4.42624L32.5496 3.91515L33.2562 7.74379L37.0848 8.4504L36.5738 12.31L39.9967 14.1652L38.3179 17.6779L41 20.5L38.3179 23.3221L39.9967 26.8348L36.5738 28.69L37.0848 32.5496L33.2562 33.2562L32.5496 37.0848L28.69 36.5738L26.8348 39.9967L23.3221 38.3179L20.5 41L17.6779 38.3179L14.1652 39.9967L12.31 36.5738L8.4504 37.0848L7.74379 33.2562L3.91515 32.5496L4.42624 28.69L1.00334 26.8348L2.6821 23.3221L0 20.5L2.6821 17.6779L1.00334 14.1652L4.42624 12.31L3.91515 8.4504L7.74379 7.74379L8.4504 3.91515L12.31 4.42624L14.1652 1.00334L17.6779 2.6821L20.5 0Z",
    fill: "#E48358"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 20.5C37 29.6127 29.6127 37 20.5 37C11.3873 37 4 29.6127 4 20.5C4 11.3873 11.3873 4 20.5 4C29.6127 4 37 11.3873 37 20.5Z",
    fill: "#E48358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 20.5C35 28.5081 28.5081 35 20.5 35C12.4919 35 6 28.5081 6 20.5C6 12.4919 12.4919 6 20.5 6C28.5081 6 35 12.4919 35 20.5Z",
    stroke: "#D78F6E",
    strokeWidth: 4
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 20.5C31 26.299 26.299 31 20.5 31C14.701 31 10 26.299 10 20.5C10 14.701 14.701 10 20.5 10C26.299 10 31 14.701 31 20.5Z",
    fill: "#E6A689"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6406 25L16.7188 24.3516L14.6719 24.1094V15.7422H14.4531L11.1719 16.3438L11.125 16.9453H13.0781V24.0547L11.0156 24.4219L10.9531 25H16.6406ZM21.5312 25.2109C22.099 25.2109 22.625 25.0625 23.1094 24.7656C23.5938 24.4635 23.9896 23.9557 24.2969 23.2422C24.6094 22.5286 24.7656 21.5885 24.7656 20.4219C24.7656 19.3229 24.6328 18.4141 24.3672 17.6953C24.1016 16.9766 23.7318 16.4479 23.2578 16.1094C22.7839 15.7708 22.224 15.6016 21.5781 15.6016C20.974 15.6016 20.4193 15.776 19.9141 16.125C19.4141 16.4688 19.0104 17.0026 18.7031 17.7266C18.401 18.4505 18.25 19.349 18.25 20.4219C18.25 22.1979 18.5469 23.4401 19.1406 24.1484C19.7344 24.8568 20.5312 25.2109 21.5312 25.2109ZM21.5156 16.4219C21.9219 16.4219 22.237 16.5677 22.4609 16.8594C22.6849 17.1458 22.8411 17.5755 22.9297 18.1484C23.0182 18.7214 23.0625 19.4792 23.0625 20.4219C23.0625 21.3698 23.0156 22.1354 22.9219 22.7188C22.8333 23.3021 22.6823 23.737 22.4688 24.0234C22.2552 24.3099 21.9583 24.4531 21.5781 24.4531C21.1406 24.4531 20.8021 24.3099 20.5625 24.0234C20.3281 23.737 20.1641 23.3099 20.0703 22.7422C19.9818 22.1693 19.9375 21.4036 19.9375 20.4453C19.9375 19.5026 19.9818 18.7422 20.0703 18.1641C20.1641 17.5859 20.3255 17.151 20.5547 16.8594C20.7839 16.5677 21.1042 16.4219 21.5156 16.4219ZM27.4609 21.8047V23.5547L28.3359 23.6406L28.3203 21.8047H29.9453L30.0391 21.0156H28.3203L28.3125 19.3047L27.4609 19.2109V21.0156H25.8281L25.7344 21.8047H27.4609Z",
    fill: "#AE6D38"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 52
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 21.6064L25.2735 25.9912L14.7736 52L10.0281 46.9806L2.99998 47.6153L13.4999 21.6064Z",
    fill: "#BB3027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1385 21L14.3649 25.3847L24.8648 51.3936L29.6103 46.3742L36.6384 47.0088L26.1385 21Z",
    fill: "#BB3027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0L23.3221 2.6821L26.8348 1.00334L28.69 4.42624L32.5496 3.91515L33.2562 7.74379L37.0848 8.4504L36.5738 12.31L39.9967 14.1652L38.3179 17.6779L41 20.5L38.3179 23.3221L39.9967 26.8348L36.5738 28.69L37.0848 32.5496L33.2562 33.2562L32.5496 37.0848L28.69 36.5738L26.8348 39.9967L23.3221 38.3179L20.5 41L17.6779 38.3179L14.1652 39.9967L12.31 36.5738L8.4504 37.0848L7.74379 33.2562L3.91515 32.5496L4.42624 28.69L1.00334 26.8348L2.6821 23.3221L0 20.5L2.6821 17.6779L1.00334 14.1652L4.42624 12.31L3.91515 8.4504L7.74379 7.74379L8.4504 3.91515L12.31 4.42624L14.1652 1.00334L17.6779 2.6821L20.5 0Z",
    fill: "#352929"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20.5C35 28.5081 28.5081 35 20.5 35C12.4919 35 6 28.5081 6 20.5C6 12.4919 12.4919 6 20.5 6C28.5081 6 35 12.4919 35 20.5Z",
    fill: "#372F2A",
    stroke: "#403831",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31 20.5C31 26.299 26.299 31 20.5 31C14.701 31 10 26.299 10 20.5C10 14.701 14.701 10 20.5 10C26.299 10 31 14.701 31 20.5Z",
    fill: "#544E48"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9174 -6L42 16.5L0.5 30L-5.5 6.17949L30.9174 -6Z",
    fill: "#544E48"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8L11.1752 9.8248L13 10.5L11.1752 11.1752L10.5 13L9.82477 11.1752L8 10.5L9.82477 9.8248L10.5 8Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_110",
    x: -4,
    y: 0,
    width: 49,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_110",
    x: 0,
    y: 4,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_110",
    x: 6.95309,
    y: 15.6016,
    width: 27.086,
    height: 17.6093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_110",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTen);
export default __webpack_public_path__ + "static/media/ten.33ca436d8f2e2b44a9e9a55abaa6c347.svg";
export { ForwardRef as ReactComponent };